import React from "react";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from "@mui/material";
import { formatPersonName } from "../../../utils/formatPersonName";

const DeleteDialog = ({ open, onClose, onConfirm, user }) => {
  const formattedFullName = formatPersonName(user?.full_name) || "Usuário";

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirmar Exclusão</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Deseja realmente excluir o usuário <strong>{formattedFullName}</strong>?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          onClick={() => {
            onConfirm();
          }}
          color="error"
          variant="contained"
        >
          Confirmar
        </Button>

      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
